import * as R from 'ramda';
import { newFormModel } from './newForm';

import {
    LOAD_FORMS,
    NEW_FORM,
    UPDATE_NEW_FORM,
    RESET_NEW_FORM,
    SELECTED_FORM,
    RESET_SELECTED_FORM,
    LOADING_START,
    LOADING_DONE
} from './constants';

const defaultState = {
    list: [],
    selected: null,
    loading: false,
    newForm: newFormModel()
};

const forms = (state = defaultState, { type, payload }) => {
    let newForm;
    switch (type) {
        case LOAD_FORMS:
            return R.merge(state, { list: payload });
        case UPDATE_NEW_FORM:
            newForm = R.merge(state.newForm, payload);
            return R.merge(state, { newForm });
        case RESET_NEW_FORM:
            newForm = newFormModel();
            return R.merge(state, { newForm });
        case NEW_FORM:
            const list = R.append(payload, state.list);
            return R.merge(state, { list });
        case SELECTED_FORM:
            return R.merge(state, { selected: payload });
        case RESET_SELECTED_FORM:
            return R.merge(state, { selected: null });
        case LOADING_START:
            return R.merge(state, { loading: true });
        case LOADING_DONE:
            return R.merge(state, { loading: false });
        default:
            return state;
    }
}

export default forms;
